export default __webpack_public_path__ + "81b8ac5fc7d28a10b3326374def48999.png";